export default __webpack_public_path__ + "static/media/i_bus-dbl_rd_dup_tagless.0eb2fb07.svg";